var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"main-card-body d-flex_cus"},[(_vm.show)?_c('h1',{staticClass:"uppercase text-center mt-4 hello-text"},[_vm._v("\n        Xin chào \""+_vm._s(_vm.fullName)+"\"\n      ")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }